














































































import * as Vue from '@vue/composition-api'
export default Vue.createComponent({
  name: 'OderCheck',
  props: {
    previewData: {
      type: String
    }
  },
  setup (props, ctx) {
    const data = Vue.reactive({
      typeName: 'broach'
    })
    const typeSelect = (typeName: string) => {
      data.typeName = typeName
    }
    const cancel = () => {
      ctx.emit('cancel')
    }
    const go = () => {
      ctx.emit('go', data.typeName)
    }

    return {
      data,
      typeSelect,
      cancel,
      go
    }
  }
})
